/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

const baseUrl = localStorage.getItem('REACT_APP_API_URL') || process.env.REACT_APP_API_URL || 'https://api.staging.partiu.com.br/api';

export function isAuthenticated() {
  return (
    axiosInstanceV2.defaults.headers.common['Authorization'] && axiosInstance.defaults.headers.common['Authorization']
  );
}
function validateStatus(status: number): boolean {
  if (status === 401) {
    setAccessToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('agreementId');
    window.location.reload();
  }
  return status < 400;
}

function configRequest(config: any) {
  const agreementId = localStorage.getItem('agreementId');

  try {
    if (
      agreementId !== null &&
      agreementId !== undefined &&
      agreementId !== 'null' &&
      agreementId !== '' &&
      !isNaN(Number(agreementId))
    ) {
      config.headers['x-agreement-id'] = Number(agreementId);
    }
  } catch (error) {
    console.error('Error setting x-agreement-id header:', error);
  }

  return config;
}

export function setAccessToken(token: string | null) {
  if (token === null) {
    axiosInstance.defaults.headers.common['Authorization'] = null;
    axiosInstanceV2.defaults.headers.common['Authorization'] = null;
    axiosInstanceV3.defaults.headers.common['Authorization'] = null;
    localStorage.removeItem('token');
    localStorage.removeItem('agreementId');
  } else {
    axiosInstance.defaults.headers.common['Authorization'] = `TOKEN ${token}`;
    axiosInstanceV2.defaults.headers.common['Authorization'] = `TOKEN ${token}`;
    axiosInstanceV3.defaults.headers.common['Authorization'] = `TOKEN ${token}`;
    localStorage.setItem('token', token);
  }
}

export const axiosInstance = axios.create({
  baseURL: baseUrl + '/v1',
  validateStatus,
});

export const axiosInstanceV2 = axios.create({
  baseURL: baseUrl + '/v2',
  validateStatus,
});

export const axiosInstanceV3 = axios.create({
  baseURL: baseUrl + '/v3',
  validateStatus,
});

axiosInstance.interceptors.request.use(configRequest);
axiosInstanceV2.interceptors.request.use(configRequest);
axiosInstanceV3.interceptors.request.use(configRequest);

const token = localStorage.getItem('token');

if (token) setAccessToken(token);
